"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const customEventSaga_1 = tslib_1.__importDefault(require("../customEvent/customEventSaga"));
const createDynamicModuleLoaderCustomEvent = () => ({
    id: 'custom-event',
    sagas: [customEventSaga_1.default],
});
exports.default = createDynamicModuleLoaderCustomEvent;
